<template>
  <!-- 待收货详情页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar title="订单详情" left-arrow @click-left="$router.go(-1)" />
    </div>
    <div class="orderStatus">
      <img src="../../assets/img/icon/组 6991@2x.png" alt="" />
      <h4>商品待收货</h4>
    </div>
    <div
      class="Logistics"
      @click="
        $router.push({
          path: '/Logistics',
          query: { orderCode: order_code },
        })
      "
      v-if="contextShow == true"
    >
      <van-steps direction="vertical" :active="0">
        <van-step>
          <p class="LogisticsInfo">{{ context }}</p>
          <van-icon name="arrow" />
          <p class="LogisticsTime">{{ fstime }}</p>
        </van-step>
      </van-steps>
    </div>
    <div
      class="Logistics"
      @click="$toast('暂无最新动态')"
      v-if="contextShow == false"
    >
      <van-steps direction="vertical" :active="0">
        <van-step>
          <p class="LogisticsInfo">{{ context }}</p>
          <van-icon name="arrow" />
        </van-step>
      </van-steps>
    </div>
    <div class="address">
      <div class="mobile">
        <span class="nameLeft">收件人：{{ this.AddressList.consignee }}</span>
        <span class="mobileRight">{{ mobile }} </span>
      </div>
      <p>{{ this.AddressList.address_str }}</p>
    </div>
    <div class="product">
      <van-card
        v-for="item in productList"
        :key="item.id"
        :num="item.num"
        :price="Number(item.oldPrice).toFixed(2)"
        :desc="item.color_name"
        :title="item.goods_detail_name"
        :thumb="item.color_img"
        @click="toShopping(item.id)"
      >
        <template #num>
          <span>{{ "共" + item.num + "件" }}</span>
        </template>
      </van-card>
      <van-field
        v-if="this.LeavingAMessage != ''"
        v-model="LeavingAMessage"
        rows="2"
        autosize
        label="买家留言"
        type="textarea"
        show-word-limit
        disabled
      />
    </div>
    <div class="preferential">
      <van-cell-group class="info">
        <van-cell title="下单编号" :value="this.order_code" />
        <van-cell title="下单时间" :value="this.time" />
      </van-cell-group>
    </div>
    <div class="productMoney">
      <van-cell-group class="info">
        <van-cell title="商品金额" class="money" :value="'￥' + this.money" />
        <van-cell title="运费" value="￥0" />
        <van-cell title="优惠券" value="暂无可用" />
      </van-cell-group>
    </div>
    <div class="btnBox">
      <van-button
        @click="
          $router.push({
            path: '/bill',
            query: { orderCode: $route.query.orderCode },
          })
        "
        color="#999999"
        size="small"
        plain
        round
        >查看发票</van-button
      >
      <van-button
        @click="
          $router.push({
            path: '/Logistics',
            query: { orderCode: $route.query.orderCode },
          })
        "
        color="#939393"
        size="small"
        plain
        round
        >查看物流</van-button
      >
      <van-button
        class="evaluate"
        @click="toPayMoney"
        color="#939393"
        size="small"
        plain
        round
        >确认收货</van-button
      >
    </div>
    <van-loading
      color="#1989fa"
      size="1rem"
      vertical
      v-show="LoadingShow"
      type="spinner"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      LoadingShow: true,
      radio: "1",
      messages: "",
      LeavingAMessage: "",
      AddressList: {},
      AddressShow: false,
      productList: {},
      order_code: "",
      money: "",
      time: "",
      context: "",
      fstime: "",
      contextShow: false,
      mobile: "",
      invoiceStatus:''
    };
  },
  created() {
    this.getAddressList();
    this.getLogistics();
  },
  methods: {
    // 确认收货
    async toPayMoney() {
      this.$dialog
        .confirm(
          await {
            title: "提示",
            message: "请确认是否收到货物",
            confirmButtonColor: "#F74B2E",
          }
        )
        .then(() => {
          this.LoadingShow = true;
          let orderCode = this.$route.query.orderCode;
          this.$post({
            url: "oor/confirmRecord",
            method: "get",
            params: {
              recordCode: orderCode,
              status: 5,
            },
          })
            .then((res) => {
              if (res.retCode == 200) {
                this.$toast("已确认收货！");
                setInterval(() => {
                  this.LoadingShow = false;
                }, 1500);
                this.$router.push("/myOrder2");
              } else {
                this.$toast("加载失败");
              }
            })
            .catch((err) => {
              this.$toast("加载失败");
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 获取地址及商品信息
    async getAddressList() {
      let orderCode = this.$route.query.orderCode;
      await this.$post({
        url: "oor/findOrderDetailByOrderCode",
        method: "get",
        params: {
          orderCode,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.invoiceStatus=res.data.invoiceStatus
            this.AddressList = res.data.addressInfo;
            this.mobile = this.AddressList.mobile.replace(
              this.AddressList.mobile.substr(3, 4),
              "****"
            );
            this.LeavingAMessage = res.data.orderDetail[0].remark;
            this.order_code = res.data.orderDetail[0].record_code;
            this.money = res.data.accountMoney;
            this.time = res.data.add_time;
            this.productList = res.data.orderDetail;
          }
        })
        .catch((err) => {
          return;
        });
    },
    // 获取物流信息
    async getLogistics() {
      let orderCode = this.$route.query.orderCode;
      await this.$post({
        url: "/oor/findLOGByCode",
        method: "get",
        params: {
          recordCode: orderCode,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.LoadingShow = false;
            if (res.data.data2 !== undefined) {
              let AcceptStation = res.data.data2.reverse();
              this.context = AcceptStation[0].AcceptStation;
              this.fstime = AcceptStation[0].AcceptTime;
              this.contextShow = true;
            } else {
              this.context = res.data.message;
              this.contextShow = false;
            }
          } else {
            this.$toast(res.message);
          }
        })
        .catch((err) => {
          this.$toast("暂无物流信息");
        });
    },
    toShopping(id) {
      sessionStorage.setItem("P_ID", id);
      this.$router.push("/toShopping");
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  position: relative;
  background-color: #f9f9f9;
  padding-bottom: 0.5rem;
  padding-top: 1rem;
  .orderStatus {
    padding: 0.35rem 0.27rem;
    height: 1.5rem;
    background-color: #fff;
    box-sizing: border-box;
    img {
      margin-top: 0.1rem;
      margin-left: 0.2rem;
      width: 1rem;
      height: 1rem;
      float: left;
    }
    h4 {
      float: left;
      line-height: 1rem;
      font-size: 0.4rem;
      font-family: PingFang SC;
    }
  }
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    background-color: #ffffff;
    .van-nav-bar {
      background-color: #40000000;
      .van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          margin-top: 0.1rem;
          color: #030303;
          font-size: 0.533333rem;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 600 !important;
      }
    }
  }
  .Logistics {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    background-color: #fff;
    padding: 0.5rem 0 0.5rem 0;
    .van-icon {
      font-size: 0.43rem;
      float: right;
      color: #333;
    }
    .LogisticsInfo {
      width: 7.8rem;
      display: inline-block;
      color: #333;
    }
    .LogisticsTime {
      margin-top: 0.27rem;
      color: #666666;
    }
    .van-steps {
      padding-left: 0.27rem;
      /deep/.van-step__circle-container {
        .van-icon {
          display: none !important;
        }
      }
    }
  }
  .address {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    background-color: #fff;
    padding-top: 0.53rem;
    .mobile {
      padding: 0 0.27rem;
      overflow: hidden;
      font-size: 0.4rem;

      .nameLeft {
        float: left;
      }
      .mobileRight {
        position: relative;
        float: right;
        text-align: center;
        vertical-align: middle;
        color: #333;
        .van-icon {
          top: -0.04rem;
          font-size: 0.4rem;
          vertical-align: middle;
        }
      }
    }
    p {
      padding: 0.48rem 0.27rem;
      font-size: 0.4rem;
      color: #999999;
    }
    .addressInfo {
      padding: 0.3rem 0.27rem;
    }
  }
  .payFashion {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    background-color: #fff;
    .van-radio-group {
      .van-cell-group {
        .van-cell.van-cell--clickable {
          position: static;
          border-bottom: none;
          img {
            width: 0.61rem;
            height: 0.61rem;
            margin-right: 0.27rem;
          }
        }
      }
    }
  }
  .product {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    padding: 0.53rem 0;
    background-color: #fff;
    .van-card {
      background-color: #fff;
      padding: 0;
      .van-card__header {
        .van-card__content {
          margin-left: 0.87rem;
          .van-card__bottom {
            .van-card__price {
              color: #f74b2e;
              font-size: 0.37rem;
            }
            .van-card__num {
              margin-right: 0.4rem;
              color: #333;
            }
          }
          .van-card__title {
            line-height: normal;
            font-size: 0.43rem;
            color: #333333;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          .van-card__desc {
            width: 4.5rem;
            padding-top: 0.2rem;
            color: #666666;
          }
        }
        .van-card__thumb {
          /deep/img {
            margin-left: 0.27rem;
            display: block;
            // width: 2.88rem;
            // height: 2.24rem;
          }
        }
      }
      .van-card__footer {
        margin-top: 0.45rem;
        .van-cell {
          padding: 0;
          /deep/.van-field__label {
            width: 1.8rem;
            text-align-last: left;
          }
        }
      }
    }
    /deep/.van-cell {
      .van-cell__title {
        span {
          font-size: 0.37rem !important;
          color: #333333 !important;
        }
      }
    }
  }
  .preferential {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    background-color: #fff;
    .van-cell__value {
      color: #333;
    }
    .van-cell.van-cell--clickable.van-coupon-cell {
      position: static;
    }
    /deep/[class*="van-hairline"]::after {
      border: 0 solid #ffffff !important;
    }
  }
  .productMoney {
    width: 9.2rem;
    margin: 0 auto;
    margin-top: 0.27rem;
    background-color: #fff;
    margin-bottom: 1rem;
    .van-cell__value {
      color: #333;
    }
    /deep/[class*="van-hairline"]::after {
      border: 0 solid #ffffff !important;
    }
    .van-swipe-cell {
      .van-swipe-cell__wrapper {
        .van-cell {
          .van-cell__value {
            color: #000;
          }
        }
      }
    }
    .fare {
      .van-swipe-cell__wrapper {
        .van-cell {
          .van-cell__value {
            color: red;
          }
        }
      }
    }
  }
  .btnBox {
    position: fixed;
    bottom: 0;
    height: 1.2rem;
    width: 100%;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .van-button {
      height: 0.72rem;
      margin-right: 0.4rem;
      color: #333333 !important;
      border-color: #999999;
    }
    .evaluate {
      background-color: #f74b2e;
      border-color: #f74b2e !important;
      color: #ffffff !important;
    }
  }
  .van-loading {
    z-index: 99;
    position: fixed;
    top: 53%;
    left: 50%;
    transform: translate(-50%);
  }
}
</style>
